<template>
  <div>
    <v-hover
      v-slot:default="{ hover }"
      :disabled="restrictPlaylistAccess">
      <v-text-field
        class="subtitle-1 resourceText pl-0"
        v-model.trim="moduleLink.name"
        :error-messages="linkNameErrors"
        hide-details="auto"
        dense
        solo
        flat
        :append-icon="hover && !showSlideout ? 'mdi-delete' : ''"
        :disabled="isUpdating || restrictPlaylistAccess || showSlideout"
        @input="$v.moduleLink.name.$touch()"
        @blur="updateLink"
        @keyup.enter="updateLink"
        @click:append="handleRemoveLink">
          <template v-slot:prepend>
            <v-avatar
              tile
              size="18"
              class="ml-3 linkFavicon">
              <img
                :src="linkFaviconURL">
            </v-avatar>
          </template>
        </v-text-field>
    </v-hover>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions,
} from 'vuex';
// Validations from Vuelidate
import {
  required,
} from 'vuelidate/lib/validators';
import _ from 'lodash';

export default {
  name: 'DraggableLink',
  props:
    [
      'moduleId',
      'moduleLink',
    ],
  data: () => ({
    resourceName: null,
  }),
  computed: {
    ...mapState([
      'isUpdating',
      'passbackBulbs',
      'showSlideout',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
    linkFaviconURL() {
      return `https://www.google.com/s2/favicons?domain=${this.moduleLink.link.url}`;
    },
    linkNameErrors() {
      const errors = [];
      if (!this.$v.moduleLink.name.$dirty) return errors;
      if(!this.$v.moduleLink.name.required) {
        errors.push('Link name is required.');
      }
      return errors;
    },
  },
  methods: {
    ...mapActions([
      'removeItem',
      'updateResourceName',
    ]),
    handleRemoveLink() {
      this.removeItem({
        playlistId: this.playlistId,
        moduleId: this.moduleId,
        oldItemIndex: this.moduleLink.order,
        itemId: this.moduleLink.itemId,
        type: 'link',
      });
    },
    updateLink() {
      if (!this.$v.moduleLink.name.$error && this.$v.moduleLink.name.$dirty) {
        this.$v.moduleLink.name.$reset();
        this.updateResourceName(this.moduleLink);
      }
    },
  },
  created() {
    this.resourceName = _.get(this.moduleLink, 'name') || _.get(this.moduleLink, 'link.name', '');
  },
  validations: {
    moduleLink: {
      name: {
        required,
      },
    },
  },
};
</script>

<style>
  .resourceText input {
    font-size: 0.875rem;
    line-height: 1.2 !important;
    color: #000000;
    color: rgba(0, 0, 0, 0.6) !important;
  }
  .v-input__slot {
    padding-left: 2px !important;
  }
  .linkFavicon {
    margin-top: 2px;
  }
</style>
